



















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import CouponSelect from '@/components/coupon-select/index.vue'
import RechargeActivityApi from '@/api/marketing/rechargeActivity/index'
import MallConfigApi from '@/api/mall/mallConfig/index'
import CustomTable from '@/components/custom-table/index.vue'
import CustomTableApi from '@/api/customTable/api'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {
    CouponSelect,
    CustomTable,
  },
})
export default class RechargeActivity extends AbpBase {
  currentTab: string = 'basicForm'
  activityId: string = ''
  levelList: any[] = []
  storeApi: string = CustomTableApi.storeApi
  vipApi: string = CustomTableApi.vipApi
  storeFilters: any[] = [
    {
      label: '关键字搜索',
      type: 'input',
      props: {
        placeholder: '请输入店铺关键字',
      },
      key: 'KeyWord',
    },
  ]
  storeColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '名称',
      key: 'displayName',
      align: 'center',
    },
    {
      title: '编码',
      key: 'code',
      align: 'center',
    },
    {
      title: '地址',
      key: 'detailAddress',
    },
    {
      title: '启用',
      key: 'isActive',
      slot: 'isActive',
      align: 'center',
    },
  ]
  selectStoreColumns: any[] = [
    {
      title: '名称',
      key: 'name',
      align: 'center',
    },
    {
      title: 'ID',
      key: 'value',
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 100,
    },
  ]
  vipFilters: any[] = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'filter',
    },
    {
      label: '注册时间',
      type: 'datetimerange',
      key: 'dateTimeRange',
      props: {
        placeholder: '请选择注册时间范围',
      },
    },
  ]
  vipColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '昵称',
      key: 'nickName',
      align: 'center',
      // width: 150,
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
      // width: 150,
    },
    {
      title: '等级',
      key: 'level',
      align: 'center',
      // width: 100,
    },
    {
      title: '积分',
      key: 'bonus',
      align: 'center',
      // width: 100,
    },
    {
      title: '注册时间',
      slot: 'creationTime',
      align: 'center',
      // width: 140,
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
      // width: 100,
    },
  ]
  selectVipColumns: any[] = [
    {
      title: '昵称',
      key: 'name',
      align: 'center',
      // width: 150,
    },
    {
      title: 'ID',
      key: 'value',
      align: 'center',
      // width: 100,
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 100,
    },
  ]
  birthList: any[] = [
    {
      type: 0,
      name: '天',
    },
    {
      type: 1,
      name: '周',
    },
    {
      type: 2,
      name: '月',
    },
  ]
  formItem = {
    name: '',
    beginTime: null,
    endTime: null,
    ruleItems: [
      {
        rechargeAmount: 0,
        giveAmount: 0,
        dayCount: null,
        shopIds: [],
        vipInfoIds: [],
        cardLevels: [],
        checkType: 0,
        startTime: null,
        endTime: null,
        inDay: null,
        consumptionCount: null,
        consumptionAmount: null,
        birthType: null,
        isRechargeRefresh: true,
        isReturnRefresh: true,
        remark: '',
        selectedStoreItems: [],
        selectedVipItems: [],
        // giveIntegral: 0,
        // giveLevel: '',
        // coupons: [],
      },
    ],
  }
  ruleValidate = {
    name: [{ required: true, message: '活动标题不能为空', trigger: 'blur' }],
    // rechargeAmount: [{ required: true, message: '充值金额不能为空', trigger: 'blur' }],
    // giveAmount: [{ required: true, message: '赠送代金券不能为空', trigger: 'blur' }],
    // dayCount: [{ required: true, message: '有效期不能为空', trigger: 'blur' }],
    beginTime: [
      {
        required: true,
        validator: this.validBeginTime,
        trigger: 'change',
      },
    ],
    endTime: [
      {
        required: true,
        validator: this.validEndTime,
        trigger: 'change',
      },
    ],
  }
  addRuleItem() {
    this.formItem.ruleItems.push({
      rechargeAmount: 0,
      giveAmount: 0,
      dayCount: null,
      shopIds: [],
      checkType: 0,
      vipInfoIds: [],
      cardLevels: [],
      startTime: null,
      endTime: null,
      inDay: null,
      consumptionCount: null,
      consumptionAmount: null,
      birthType: null,
      isRechargeRefresh: true,
      isReturnRefresh: true,
      remark: '',
      selectedStoreItems: [],
      selectedVipItems: [],
      // giveIntegral: 0,
      // giveLevel: '',
      // coupons: [],
    })
  }

  // change(index, e) {
  //   this.formItem.ruleItems[index].coupons = e.map((x) => {
  //     return {
  //       id: x.id,
  //       code: x.code,
  //       couponName: x.name,
  //       giveCount: 1,
  //     }
  //   })
  // }
  deleteRuleItem(index) {
    this.formItem.ruleItems.splice(index, 1)
  }
  // deleteCoupon(index, couponIndex) {
  //   this.formItem.ruleItems[index].coupons.splice(couponIndex, 1)
  // }
  validBeginTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择开始日期'))
    } else {
      ;(this.$refs as any).basicForm.validateField('endTime')
    }
    callback()
  }
  validEndTime(rule, value, callback) {
    if (value === '') {
      callback(new Error('请选择结束日期'))
    }
    if (value < this.formItem.beginTime) {
      callback(new Error('结束日期必须大于开始日期'))
    }
    callback()
  }
  save() {
    ;(this.$refs['basicForm'] as any).validate((valid) => {
      if (valid) {
        let isFillAll = this.formItem.ruleItems.every((item) => {
          return item.rechargeAmount > 0 && item.giveAmount >= 0 && item.dayCount >= 0
        })
        if (!isFillAll) {
          this.currentTab = 'ruleConfigForm'
          this.$Notice.warning({
            desc: '请填写完成必要条件',
          })
          return
        }
        if (this.activityId) {
          RechargeActivityApi.update(this.activityId, this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'recharge',
            })
          })
        } else {
          console.log(this.formItem)
          RechargeActivityApi.add(this.formItem).then((res) => {
            this.$Message.success('保存成功')
            this.$router.push({
              name: 'recharge',
            })
          })
        }
      }
    })
  }
  created() {
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString()
      this.loadActivity()
    }
    this.loadLevelList()
  }
  loadActivity() {
    RechargeActivityApi.get(this.activityId).then((res) => {
      res.data.ruleItems.forEach((item) => {
        item.selectedStoreItems = item.shopIds.map((itemShop) => itemShop.value)
        item.selectedVipItems = item.vipInfoIds.map((itemVip) => itemVip.value)
        // item.startTime = item.startTime ? new Date(item.startTime) : null;
        // item.endTime = item.endTime ? new Date(item.endTime) : null;
      })
      this.formItem = res.data
      this.formItem.beginTime = new Date(res.data.beginTime)
      this.formItem.endTime = new Date(res.data.endTime)
    })
  }
  loadLevelList() {
    MallConfigApi.getMallConfig('MemberLevelConfig').then((res) => {
      this.levelList = res.data.Items
    })
  }
  removeItem(row: any, index: number, type: string) {
    switch (type) {
      case 'store':
        this.formItem.ruleItems[index].shopIds.splice(row._index, 1)
        this.formItem.ruleItems[index].selectedStoreItems.splice(row._index, 1)
        break
      case 'vip':
        this.formItem.ruleItems[index].vipInfoIds.splice(row._index, 1)
        this.formItem.ruleItems[index].selectedVipItems.splice(row._index, 1)
        break
      default:
        break
    }
  }
  handleSelectCustomTable(e: any, type: string, index: number) {
    console.log(e, type)
    switch (type) {
      case 'store':
        let storeArr = e.map((item) => {
          return {
            name: item.displayName,
            value: item.id,
          }
        })
        this.formItem.ruleItems[index].shopIds = this.formItem.ruleItems[index].shopIds.concat(storeArr)
        this.formItem.ruleItems[index].selectedStoreItems = this.formItem.ruleItems[index].selectedStoreItems.concat(
          e.map((item) => item.id)
        )
        break
      case 'vip':
        let vipArr = e.map((item) => {
          return {
            name: item.nickName,
            value: item.id,
          }
        })
        this.formItem.ruleItems[index].vipInfoIds = this.formItem.ruleItems[index].vipInfoIds.concat(vipArr)
        this.formItem.ruleItems[index].selectedVipItems = this.formItem.ruleItems[index].selectedVipItems.concat(
          e.map((item) => item.id)
        )
        break

      default:
        break
    }
  }
}
